<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-user-check"></i></div>
      <div>
        Présence du jour
        <div class="page-title-subheading">Fiche de présence de la journée</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
<div class="row">
    <div class="form-group col-12 col-md-4">
        <label for="">Classe</label>
        <ng-select (change)="loadPacs($event)">
            <ng-option *ngFor="let c of classrooms" [value]="c.id">{{c.name}}</ng-option>
        </ng-select>
    </div>
    <div class="form-group col-12 col-md-4">
        <label for="">Séance</label>
        <ng-select name="paccId" [(ngModel)]="paccId">
            <ng-option *ngFor="let c of courses" [value]="c.pivot.id">{{c.name}}</ng-option>
        </ng-select>
    </div>
    <div class="form-group col-12 col-md-4">
        <label for="">Période</label>
        <ng-select name="periodId" [(ngModel)]="periodId">
            <ng-option *ngFor="let p of periods" [value]="p.id">{{p.name}}</ng-option>
        </ng-select>
    </div>
    <div class="form-group col-12 col-md-4">
        <label for="">Choix de la catégorie</label>
        <ng-select name="category" [(ngModel)]="category" (change)="loadList($event)"  >
            <ng-option *ngFor="let a of attendances" [value]="a">{{a}}</ng-option>
        </ng-select>
    </div>
</div>


<div class="container">
    <div class="card">
        <div class="card-body">
            <table class="table table-sm">
                <thead>
                    <th>#</th>
                    <th>Nom et prénom(s)</th>
                    <th>Etat</th>
                </thead>
                <tbody>
                    <tr *ngFor="let d of data; let i=index">
                        <td>{{i+1}}</td>
                        <td>{{d.identity}}</td>
                        <th>
                            <div class="form-group">
                                <label for="">Statut</label>
                                <select name="{{d.type}}" [(ngModel)]="d.type" class="form-control-sm">
                                    <option *ngFor="let ac of attendance_categories" [value]="ac">{{ac}}</option>
                                </select>
                            </div>
                            <ng-container *ngIf="d.type == 'Retard'">
                            <div class="form-group">
                                <label for="">Heure d'arrivée : </label>
                                <input type="datetime-local" class="form-control-sm">
                            </div>
                            </ng-container>    
                            <ng-container *ngIf="d.type == 'Absent'">
                            <div class="form-group">
                                <label for="">Motif : </label>
                                <input type="text" class="form-control-sm">
                            </div>
                            <div *ngIf="d.file != null" >
                                <button (click)="removeFile(i)" class="btn btn-sm btn-danger">Retirer le fichier</button>
                            </div>
                            <div *ngIf="d.file == null"  class="input-group mb-3">
                                <input type="file" class="form-control-sm" (change)="upload($event,i)">
                              </div>
                            </ng-container>    
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer text-center">
            <button (click)="store()" class="btn btn-sm btn-success">Enregistrer la fiche</button>
        </div>
    </div>
</div>
